/** Global decimal places for ExpressionV2 / footer numeric formatting. */
export const GLOBAL_DECIMAL_PLACES = 2;

/** Format a numeric value as a string with GLOBAL_DECIMAL_PLACES. */
export function formatNumericDecimal(value: unknown): string {
  if (value === "" || value === null || value === undefined) return "";
  const num = typeof value === "number" ? value : parseFloat(String(value));
  if (isNaN(num)) return String(value);
  return num.toFixed(GLOBAL_DECIMAL_PLACES);
}

/** Round a number to GLOBAL_DECIMAL_PLACES and return as number. */
export function roundNumericDecimal(value: number): number {
  return parseFloat(value.toFixed(GLOBAL_DECIMAL_PLACES));
}

/**
 * Coerce a value to a strict-mode-safe numeric literal string for ExpressionV2.
 * Prevents leading-zero strings like "01" from becoming illegal octal literals
 * under `Function('"use strict"; return (...)"')`.
 */
export function toExpressionNumericLiteral(value: unknown): string {
  if (value === undefined || value === null || value === "") return "0";
  const num =
    typeof value === "number" ? value : parseFloat(String(value).trim());
  return Number.isFinite(num) ? String(num) : "0";
}
